// VoK MUI base styles
import typography from "app/assets/theme/base/typography";
import colors from "app/assets/theme/base/colors";

// VoK MUI helper functions
// import pxToRem from "assets/theme/functions/pxToRem";

const {size} = typography;
const {text} = colors;

const dialogContentText = {
    styleOverrides: {
        root: {
            fontSize: size.md,
            color: text.main,
        },
    },
};

export default dialogContentText;
